/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AutoCompleteDropdown from "../../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { FAMILY_FIELDS } from "../../../../../contants/formFields";
import IntroductionFormApi from "../../../../../services/api/introductionForm";
import InputField from "../../../../../components/common/new/InputField/InputField";
import Styles from "./Address.styles";
import { getOptions } from "../../../../../utils";
import Button from "../../../../../components/common/Button/index";

function AddressForm({
  values,
  errors,
  handleChange,
  handleSubmit,
  setFieldValue,
  familyData,
  readOnly,
}) {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const navigate = useNavigate();

  const onCancel = () => {
    navigate(-1);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
  };

  useEffect(() => {
    getStates();
  }, []);

  useEffect(() => {
    if (states.length && values[FAMILY_FIELDS.STATE]) {
      const newCities =
        states.find(
          (state) => state.stateId === Number(values[FAMILY_FIELDS.STATE])
        )?.cities ?? [];
      setCities(newCities);
    }
  }, [states, values[FAMILY_FIELDS.STATE]]);

  useEffect(() => {
    if (familyData) {
      setFieldValue(FAMILY_FIELDS.ADDRESS_LINE_1, familyData.familyAddress);

      if (familyData?.familyMembers?.length) {
        const firstMember = familyData.familyMembers[0];
        setFieldValue(FAMILY_FIELDS.STATE, Number(firstMember.state));
        setFieldValue(FAMILY_FIELDS.CITY, Number(firstMember.city));
        setFieldValue(FAMILY_FIELDS.PINCODE, Number(firstMember.pincode));
      }
    }
  }, [familyData]);

  return (
    <>
      <Grid container spacing={0}>
        <Grid
          item
          xs={6}
          md={8}
          sx={{ marginRight: "30px", marginBottom: "20px" }}
        >
          <InputField
            required
            label="House Address"
            name={FAMILY_FIELDS.ADDRESS_LINE_1}
            value={values[FAMILY_FIELDS.ADDRESS_LINE_1] || ""}
            error={errors[FAMILY_FIELDS.ADDRESS_LINE_1]}
            onChange={handleChange}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={6} md={3.5} sx={{ marginBottom: "20px" }}>
          <InputField
            label="Pincode"
            inputProps={{ maxLength: 6 }}
            name={FAMILY_FIELDS.PINCODE}
            value={values[FAMILY_FIELDS.PINCODE] || ""}
            error={errors[FAMILY_FIELDS.PINCODE]}
            onChange={handleChange}
            disabled={readOnly}
          />
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          sx={{ marginRight: "30px", marginBottom: "20px" }}
        >
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.stateName}
            label="State"
            name={FAMILY_FIELDS.STATE}
            options={getOptions(states, "stateId")}
            error={errors[FAMILY_FIELDS.STATE]}
            value={values[FAMILY_FIELDS.STATE]}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(FAMILY_FIELDS.STATE, "");
                setCities([]);
              } else {
                setFieldValue(FAMILY_FIELDS.STATE, selectedValue.value);
                setCities(selectedValue.cities);
              }
              setFieldValue(FAMILY_FIELDS.CITY, "");
            }}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.cityName}
            label="City"
            name={FAMILY_FIELDS.CITY}
            options={getOptions(cities, "cityId")}
            error={errors[FAMILY_FIELDS.CITY]}
            value={values[FAMILY_FIELDS.CITY]}
            disabled={!values[FAMILY_FIELDS.STATE] || readOnly}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(FAMILY_FIELDS.CITY, "");
              } else {
                setFieldValue(FAMILY_FIELDS.CITY, selectedValue.value);
              }
            }}
          />
        </Grid>
      </Grid>
      {!readOnly && (
        <div style={{ display: "flex", gap: 10 }}>
          <Button
            variant="contained"
            onClick={handleSubmit}
            label="Save Changes"
            style={Styles.buttonStyle}
            type="submit"
          />

          <Button
            variant="outlined"
            onClick={onCancel}
            label=" Cancel"
            style={{ ...Styles.buttonStyle, marginLeft: "20px" }}
          />
        </div>
      )}
    </>
  );
}

export default AddressForm;
